<template>
  <div>
    <v-row>
      <v-col md="5" class="d-flex align-center">
        <v-img
          :src="require('@/assets/images/register_image.png')"
          class="ma-8"
          width="400"
        />
      </v-col>
      <v-col md="7" class="d-flex align-center">
        <div class="flex-fill">
          <h1 class="text-center">کلمه عبور</h1>
          <p class="text-center">
            لطفا یه رمز عبور برای کاربری خود انتخاب نمایید
          </p>
          <v-card class="pa-5">
            <v-form
              v-model="valid"
              @submit.prevent="handleSetPass"
              class="text-center"
            >
              <v-row>
                <v-col>
                  <v-text-field
                    outlined
                    dense
                    v-model="password"
                    label="کلمه عبور"
                    :rules="passwordRules"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                    autocomplete="off"
                    counter
                    required
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    outlined
                    dense
                    v-model="confirmPass"
                    label="تکرار کلمه عبور"
                    :rules="confirmPassRules.concat(passwordConfirmationRule)"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    hint="پسورد می بایست حداقل از 6 حرف تشکیل شده باشد"
                    autocomplete="off"
                    counter
                    required
                  />
                </v-col>
              </v-row>
              <v-btn
                :loading="loading"
                :disabled="!valid || loading"
                depressed
                color="primary"
                type="submit"
                block
              >
                ارسال
              </v-btn>
            </v-form>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "set-school-password-component",
  data: () => {
    return {
      loading: false,
      valid: true,
      show1: false,
      show2: false,
      username: "",
      password: "",
      passwordRules: [(v) => !!v || "کلمه عبور خود را وارد نمایید"],
      confirmPass: "",
      confirmPassRules: [(v) => !!v || "تکرار کلمه عبور خود را وارد نمایید"]
    };
  },
  computed: {
    passwordConfirmationRule() {
      return () => this.password === this.confirmPass || "پسور یکسان نیست";
    }
  },
  methods: {
    handleSetPass() {
      this.loading = true;
      this.$store.dispatch("setSchoolPass", {
        password: this.password
      });
    }
  }
};
</script>
